
import { Table, Button, Container, Row, Col, Stack, Pagination, Spinner } from "react-bootstrap";
import { VideoPlayer } from "./VideoPlayer";
import HLSPlayer from "./HlsPlayer";
import { Loader } from "../common/Loader";

export default function CameraGrid({
    view,
    cameras,
    activeCameras,
    currentPage,
    setCurrentPage,
    camerasPerPage,
}) {

    // ================================
    // PAGINATION
    // ================================
    const indexOfLastCamera = currentPage * camerasPerPage;
    const indexOfFirstCamera = indexOfLastCamera - camerasPerPage;
    const currentCameras = activeCameras.slice(indexOfFirstCamera, indexOfLastCamera);
    const totalPages = Math.ceil(activeCameras.length / camerasPerPage);

    // ================================
    // LIST VIEW
    // ================================
    if (view === "list") {
        return (
            <div className="lc-list table-responsive">
                <Table hover>
                    <thead>
                        <tr>
                            <th>Camera</th>
                            <th>Status</th>
                            <th>Location</th>
                            <th>Time</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {cameras.map((cam, i) => (
                            <tr key={i}>
                                <td className="d-flex align-items-center gap-2">
                                    <img src={cam.img} className="thumb" alt={cam.cameraName} />
                                    {cam.cameraName}
                                </td>
                                <td>
                                    <span className={`status ${cam.status}`}>
                                        ● {cam.status}
                                    </span>
                                </td>
                                <td>{cam.locationName || "—"}</td>
                                <td>{new Date().toLocaleTimeString()}</td>
                                <td>
                                    <Button size="sm">View</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }

    // ================================
    // GRID VIEW (default)
    // ================================
    return (
        <Container className="" fluid>

            {cameras?.length > 0 ? (
                <Row className="g-2">

                    {/* IFRAME FALLBACK — shown when no active (live stream) cameras */}
                    {currentCameras.length === 0 && cameras.length !== 0 &&
                        cameras.slice(0, camerasPerPage).map((camera, index) => (
                            <Col md={4} sm={6} lg={4} key={index}>
                                <Stack
                                    direction="vertical"
                                    gap={2}
                                    className="justify-content-center align-items-center shadow rounded p-3 m-1"
                                >
                                    {/* <iframe
                                        title={`Camera Feed - ${camera?.cameraName || camera?._id}`}
                                        src={camera?.httpsUrl}
                                        width="100%"
                                        height="100%"
                                        allow="autoplay"
                                        allowFullScreen
                                    />  */}
                                    <HLSPlayer
                                    hlsUrl={`${camera?.cameraCurrentData?.hlsUrl}`}
                                    cameraName={`${camera.cameraName}`}
                                />
                                    <Stack
                                        direction="horizontal"
                                        className="justify-content-between align-items-center px-2"
                                        gap={3}
                                    >
                                        <h6 className="text-center mb-0">{camera.cameraName}</h6>
                                    </Stack>
                                </Stack>
                            </Col>
                        ))
                    }  

                    {/* {currentCameras.length === 0 && cameras.length !== 0 && (
                        <Loader show={true} />
                    )} */}

                    {/* VIDEO PLAYER — paginated active cameras */}
                    {currentCameras.map((camera, index) => (
                        <Col md={4} sm={6} lg={4} key={index}>
                            <Stack
                                direction="vertical"
                                gap={2}
                                className="justify-content-center align-items-center shadow rounded p-3 m-1"
                            >
                                {/* <VideoPlayer
                                    wsUrl={`${camera.wsPort}`}
                                    cameraName={`${camera.cameraName}`}
                                /> */}
                                <HLSPlayer
                                    hlsUrl={`${camera?.cameraCurrentData?.hlsUrl}`}
                                    cameraName={`${camera.cameraName}`}
                                />
                                <Stack
                                    direction="horizontal"
                                    className="justify-content-between align-items-center px-2"
                                    gap={3}
                                >
                                    <h6 className="text-center mb-0">{camera.cameraName}</h6>
                                </Stack>
                            </Stack>
                        </Col>
                    ))}

                </Row>
            ) : (
                <div className="d-flex justify-content-center align-items-center py-5">
                    <div className="text-center text-muted py-5">
                        <div style={{ fontSize: "3rem" }}>📷</div>
                        <h5 className="mt-3 fw-semibold text-dark">No Camera Feed Available</h5>
                        <p className="mb-0 text-muted" style={{ maxWidth: "380px" }}>
                            Make a reservation to unlock access to the live camera feed for your assigned parking locations.
                        </p>
                    </div>
                </div>
            )}


            {/* PAGINATION */}

            {totalPages > 1 && (
                <div className="rt-pagination d-flex justify-content-end align-items-center px-3 pb-3 mt-3">
                    <Pagination className="mt-3 gap-1">
                        <Pagination.Prev
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        />
                        {[...Array(totalPages)].map((_, i) => (
                            <Pagination.Item
                                key={i}
                                active={i + 1 === currentPage}
                                onClick={() => setCurrentPage(i + 1)}
                            >
                                {i + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </div>
            )}
        </Container>
    );
}